import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../../environments/environment';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log('in');
        // add authorization header with jwt token if available
        //let currentUser = this.authenticationService.currentUserValue;
        //if (currentUser && currentUser.token) {
            if (request.url.includes("api/v3/Mobiles/CheckJwtToken")) {
                return next.handle(request);
            } else if (request.url === environment.apiUrlV5 + 'api/tpsl-route/problem-reports' ||
                       request.url === environment.apiUrlV5 + 'api/tpsl-route/session/refresh') {
                const token = localStorage.getItem('jwtToken');
                if (token) {
                    request = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
                }
                return next.handle(request);
            }else{
                request = request.clone({
                    setHeaders: { 
                        //Authorization: `Bearer ${currentUser.token}`
                        Authorization: `*NationexInternalAPI*`
                    }
                });
            return next.handle(request);
            }
    }
}
